
/* ===========================================
   DUDU AHARON — interactions
   =========================================== */

(() => {
  // ---------- LOADER ----------
  const loader = document.querySelector('.loader');
  const loaderBar = document.querySelector('.loader-bar > i');
  let progress = 0;
  const tickLoader = () => {
    progress += Math.random() * 14 + 4;
    if (progress > 100) progress = 100;
    if (loaderBar) loaderBar.style.width = progress + '%';
    if (progress < 100) {
      setTimeout(tickLoader, 120);
    } else {
      setTimeout(() => {
        loader && loader.classList.add('done');
        document.body.classList.add('loaded');
        startHeroReveal();
      }, 250);
    }
  };
  setTimeout(tickLoader, 120);

  // ---------- CUSTOM CURSOR ----------
  const dot = document.querySelector('.cursor-dot');
  const ring = document.querySelector('.cursor-ring');
  const spotlight = document.querySelector('.spotlight');
  let mx = window.innerWidth / 2, my = window.innerHeight / 2;
  let rx = mx, ry = my, sx = mx, sy = my;
  window.addEventListener('mousemove', (e) => {
    mx = e.clientX; my = e.clientY;
    if (dot) dot.style.transform = `translate(${mx}px, ${my}px) translate(-50%, -50%)`;
  });
  const animateCursor = () => {
    rx += (mx - rx) * 0.18;
    ry += (my - ry) * 0.18;
    sx += (mx - sx) * 0.06;
    sy += (my - sy) * 0.06;
    if (ring) ring.style.transform = `translate(${rx}px, ${ry}px) translate(-50%, -50%)`;
    if (spotlight) spotlight.style.transform = `translate(${sx}px, ${sy}px) translate(-50%, -50%)`;
    requestAnimationFrame(animateCursor);
  };
  animateCursor();

  document.querySelectorAll('a, button, [data-cursor="hover"]').forEach(el => {
    el.addEventListener('mouseenter', () => document.body.classList.add('cursor-hover'));
    el.addEventListener('mouseleave', () => document.body.classList.remove('cursor-hover'));
  });
  document.querySelectorAll('input, textarea, select').forEach(el => {
    el.addEventListener('mouseenter', () => document.body.classList.add('cursor-text'));
    el.addEventListener('mouseleave', () => document.body.classList.remove('cursor-text'));
  });

  // ---------- NAV scroll ----------
  const nav = document.querySelector('.nav');
  const onScroll = () => {
    if (!nav) return;
    if (window.scrollY > 40) nav.classList.add('scrolled');
    else nav.classList.remove('scrolled');
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // mobile menu
  const burger = document.querySelector('.nav-burger');
  const overlay = document.querySelector('.nav-overlay');
  if (burger && overlay) {
    burger.addEventListener('click', () => {
      overlay.classList.toggle('open');
      burger.classList.toggle('open');
    });
    overlay.querySelectorAll('a').forEach(a => a.addEventListener('click', () => {
      overlay.classList.remove('open');
      burger.classList.remove('open');
    }));
  }

  // ---------- HERO TITLE reveal ----------
  function startHeroReveal() {
    const chars = document.querySelectorAll('.hero-title .char');
    chars.forEach((c, i) => {
      c.style.animationDelay = (i * 35 + 100) + 'ms';
    });
  }

  // ---------- INTERSECTION REVEAL ----------
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('in');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
  document.querySelectorAll('.reveal, .reveal-stagger').forEach(el => io.observe(el));

  // ---------- COUNTERS ----------
  const counterIO = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        const el = e.target;
        const target = parseFloat(el.dataset.count);
        const decimals = parseInt(el.dataset.decimals || '0', 10);
        const dur = 1800;
        const start = performance.now();
        const tick = (now) => {
          const t = Math.min(1, (now - start) / dur);
          const eased = 1 - Math.pow(1 - t, 3);
          const v = target * eased;
          el.textContent = decimals ? v.toFixed(decimals) : Math.floor(v).toLocaleString();
          if (t < 1) requestAnimationFrame(tick);
          else el.textContent = decimals ? target.toFixed(decimals) : target.toLocaleString();
        };
        requestAnimationFrame(tick);
        counterIO.unobserve(el);
      }
    });
  }, { threshold: 0.6 });
  document.querySelectorAll('[data-count]').forEach(el => counterIO.observe(el));

  // ---------- MAGNETIC BUTTONS ----------
  document.querySelectorAll('[data-magnetic]').forEach(el => {
    let raf;
    const strength = parseFloat(el.dataset.magnetic) || 0.4;
    el.addEventListener('mousemove', (e) => {
      const r = el.getBoundingClientRect();
      const x = (e.clientX - (r.left + r.width / 2)) * strength;
      const y = (e.clientY - (r.top + r.height / 2)) * strength;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        el.style.transform = `translate(${x}px, ${y}px)`;
      });
    });
    el.addEventListener('mouseleave', () => {
      el.style.transform = '';
    });
  });

  // ---------- 3D TILT ----------
  document.querySelectorAll('[data-tilt]').forEach(el => {
    const max = parseFloat(el.dataset.tilt) || 10;
    let raf;
    el.addEventListener('mousemove', (e) => {
      const r = el.getBoundingClientRect();
      const px = (e.clientX - r.left) / r.width;
      const py = (e.clientY - r.top) / r.height;
      const rx = (py - 0.5) * -max;
      const ry = (px - 0.5) * max;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        el.style.transform = `perspective(900px) rotateX(${rx}deg) rotateY(${ry}deg)`;
      });
    });
    el.addEventListener('mouseleave', () => {
      el.style.transform = '';
    });
  });

  // ---------- COUNTDOWN ----------
  const countdownEl = document.querySelector('[data-countdown]');
  if (countdownEl) {
    const target = new Date(countdownEl.dataset.countdown).getTime();
    const setCell = (sel, v) => {
      const el = countdownEl.querySelector(sel);
      if (el) el.textContent = String(v).padStart(2, '0');
    };
    const tick = () => {
      const now = Date.now();
      let diff = Math.max(0, target - now);
      const days = Math.floor(diff / 86400000); diff -= days * 86400000;
      const hours = Math.floor(diff / 3600000); diff -= hours * 3600000;
      const mins = Math.floor(diff / 60000); diff -= mins * 60000;
      const secs = Math.floor(diff / 1000);
      setCell('[data-c=days]', days);
      setCell('[data-c=hours]', hours);
      setCell('[data-c=mins]', mins);
      setCell('[data-c=secs]', secs);
    };
    tick();
    setInterval(tick, 1000);
  }

  // ---------- LIGHTBOX ----------
  const lightbox = document.querySelector('.lightbox');
  if (lightbox) {
    const lbImg = lightbox.querySelector('.lightbox-img');
    const lbCount = lightbox.querySelector('[data-lb-count]');
    const lbCap = lightbox.querySelector('[data-lb-cap]');
    const tiles = [...document.querySelectorAll('.tile[data-g]')];
    let idx = 0;
    const open = (i) => {
      idx = (i + tiles.length) % tiles.length;
      const t = tiles[idx];
      lbImg.dataset.g = t.dataset.g;
      lbImg.style.background = getComputedStyle(t.querySelector('.tile-bg')).background;
      lbCap.textContent = t.querySelector('.tile-cap .t')?.textContent || '';
      lbCount.textContent = `${(idx + 1).toString().padStart(2, '0')} / ${tiles.length.toString().padStart(2, '0')}`;
      lightbox.classList.add('open');
    };
    tiles.forEach((t, i) => t.addEventListener('click', () => open(i)));
    lightbox.querySelector('.lightbox-close').addEventListener('click', () => lightbox.classList.remove('open'));
    lightbox.querySelector('.lightbox-arrow.prev').addEventListener('click', () => open(idx - 1));
    lightbox.querySelector('.lightbox-arrow.next').addEventListener('click', () => open(idx + 1));
    document.addEventListener('keydown', (e) => {
      if (!lightbox.classList.contains('open')) return;
      if (e.key === 'Escape') lightbox.classList.remove('open');
      if (e.key === 'ArrowLeft') open(idx + 1);
      if (e.key === 'ArrowRight') open(idx - 1);
    });
  }

  // ---------- FORM floating labels ----------
  document.querySelectorAll('.field select').forEach(s => {
    const update = () => {
      if (s.value) s.parentElement.classList.add('filled');
      else s.parentElement.classList.remove('filled');
    };
    s.addEventListener('change', update);
    update();
  });
  // submit fake
  const form = document.querySelector('form.form');
  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const btn = form.querySelector('.form-submit');
      const orig = btn.innerHTML;
      btn.innerHTML = '<span>נשלח ✓</span>';
      btn.style.background = '#10b981';
      setTimeout(() => {
        btn.innerHTML = orig;
        btn.style.background = '';
        form.reset();
      }, 2400);
    });
  }

  // ---------- PARALLAX hero ----------
  const heroMedia = document.querySelector('.hero-media .placeholder');
  const heroSil = document.querySelector('.hero-silhouette');
  const heroTitle = document.querySelector('.hero-title');
  window.addEventListener('scroll', () => {
    const y = window.scrollY;
    if (y > window.innerHeight) return;
    if (heroMedia) heroMedia.style.transform = `translateY(${y * 0.3}px) scale(${1 + y * 0.0005})`;
    if (heroSil) heroSil.style.transform = `translateX(-50%) translateY(${y * 0.15}px)`;
    if (heroTitle) heroTitle.style.transform = `translateY(${y * -0.1}px)`;
  }, { passive: true });

  // ---------- ACTIVE NAV section ----------
  const sections = document.querySelectorAll('section[id]');
  const navLinks = document.querySelectorAll('.nav-menu a[href^="#"]');
  const sectionIO = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        const id = e.target.id;
        navLinks.forEach(a => {
          a.classList.toggle('active', a.getAttribute('href') === '#' + id);
        });
      }
    });
  }, { threshold: 0.4 });
  sections.forEach(s => sectionIO.observe(s));

  // ---------- CONFETTI on primary CTA ----------
  const primaryCta = document.querySelector('.btn-primary[data-confetti]');
  if (primaryCta) {
    primaryCta.addEventListener('click', (e) => {
      const r = primaryCta.getBoundingClientRect();
      const cx = r.left + r.width / 2;
      const cy = r.top + r.height / 2;
      for (let i = 0; i < 28; i++) {
        const p = document.createElement('span');
        p.className = 'particle';
        p.style.cssText = `
          position: fixed; left: ${cx}px; top: ${cy}px;
          width: 8px; height: 8px;
          background: ${Math.random() > 0.5 ? '#FF0050' : '#fff'};
          border-radius: ${Math.random() > 0.5 ? '50%' : '0'};
          z-index: 5000;
          pointer-events: none;
          will-change: transform, opacity;
        `;
        document.body.appendChild(p);
        const angle = Math.random() * Math.PI * 2;
        const vel = 80 + Math.random() * 160;
        const dx = Math.cos(angle) * vel;
        const dy = Math.sin(angle) * vel - 80;
        const rot = (Math.random() - 0.5) * 720;
        p.animate([
          { transform: 'translate(-50%, -50%) rotate(0)', opacity: 1 },
          { transform: `translate(calc(-50% + ${dx}px), calc(-50% + ${dy + 240}px)) rotate(${rot}deg)`, opacity: 0 }
        ], { duration: 1100 + Math.random() * 400, easing: 'cubic-bezier(.2,.7,.3,1)' })
        .onfinish = () => p.remove();
      }
    });
  }

  // ---------- WAVEFORM ----------
  const waveCanvas = document.querySelector('.waveform');
  if (waveCanvas) {
    const ctx = waveCanvas.getContext('2d');
    const dpr = window.devicePixelRatio || 1;
    const resize = () => {
      const r = waveCanvas.getBoundingClientRect();
      waveCanvas.width = r.width * dpr;
      waveCanvas.height = r.height * dpr;
      ctx.scale(dpr, dpr);
    };
    resize();
    window.addEventListener('resize', resize);
    const bars = 80;
    const phases = Array.from({ length: bars }, () => Math.random() * Math.PI * 2);
    let t = 0;
    const draw = () => {
      const r = waveCanvas.getBoundingClientRect();
      ctx.clearRect(0, 0, r.width, r.height);
      const bw = r.width / bars;
      for (let i = 0; i < bars; i++) {
        const h = (Math.sin(t + phases[i]) * 0.4 + 0.6) * r.height * 0.7;
        ctx.fillStyle = i % 7 === 0 ? '#FF0050' : 'rgba(255,255,255,0.6)';
        ctx.fillRect(i * bw + 1, (r.height - h) / 2, bw - 2, h);
      }
      t += 0.06;
      requestAnimationFrame(draw);
    };
    draw();
  }

  // ---------- TICKER duplicate fill ----------
  document.querySelectorAll('.marquee-track, .press-track').forEach(track => {
    const clone = track.innerHTML;
    track.innerHTML = clone + clone;
  });
})();

